<template>
  <div>
    <page-title icon="fa fa-calendar-alt" main="Agenda" sub="Tipos de Visita" :help="true"
    titleHelp="Ajuda - Tipos de Visita"
    content="Responsável por listar e cadastrar novos tipos de visitas.
Para criação de um novo tipo de visita pressione o campo 'Selecione um tipo de visita' escreva o nome, clique em novo tipo e por fim pressione o botão 'Inserir Descrição'.
Para alteração de uma Campanha basta ir com o mouse em ações e clicar em Editar.
    "
    ></page-title>
    <card>
      <modal :show.sync="modals.modal0" size="lg" class="col-12">
        <template slot="header">
          <h5
            v-if="visit_type.kind"
            class="modal-title"
            id="exampleModalLabel"
          >Inserir descrição em {{ visit_type.kind.title }}</h5>
        </template>
        <form role="form" @submit.prevent="handleSubmit(save)">
          <base-input class="mb-3" v-model="visit_type.description" placeholder="Descrição">
        </base-input>
        </form>
        <template slot="footer">
          <base-button type="secondary" @click="modals.modal0 = false">Fechar</base-button>
          <base-button type="success" @click="save">
          Salvar</base-button>
        </template>
      </modal>
      <div slot="header">
        <span>Tipos de Visitas</span>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <multiselect
            v-model="visit_type.action_type"
            :options="actionTypes"
            selectLabel="Selecione uma opção"
            selectedLabel="Selecionado"
            deselectLabel="Você selecionou este item"
            @input="search"
            track-by="id"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            label="description"
            placeholder="Selecione um tipo de visita"
            group-values="types"
            group-label="origin"
            :group-select="false"
            :allow-empty="true"
            :preserveSearch="true"
            :showNoResults="false"
            @search-change="updateNewActionType"
          ></multiselect>
        </div>
        <div class="top col-md--3">
          <el-tooltip
            content="Escolha um item da lista para habilitar o botão"
            :disabled="!enableButton"
            placement="top"
          >
            <div class="col-12 mb-3">
              <base-button
               v-loading = "isLoading"
                type="success"
                size="medium"
                @click="newVisitType"
                :disabled="enableButton"
              >Inserir Descrição</base-button>
              <base-button
                class="ml-3"
                type="secondary"
                size="medium"
                @click="clearFilters"
              >Limpar Pesquisa</base-button>
            </div>
          </el-tooltip>
        </div>
      </div>
      <el-table
        v-loading = "isLoading"
        empty-text="Selecione o tipo da visita"
        class="table-responsive table-flush"
        :data="filteredVisitTypes()"
        header-row-class-name="thead-light"
      >
        <el-table-column label="descrição" min-width="310px" prop="description" sortable>
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              <div class="media-body">
                <span class="font-weight-600 name mb-0 text-sm">{{row.description }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Ações" min-width="95px" prop="acoes" v-slot="{ row }">
          <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
            <span class="btn btn-sm btn-icon-only text-success">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
              <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
              <a class="dropdown-item" href="#" @click="remove(row)">Excluir</a>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>
    </card>
  </div>
</template>
<script>
  import Vue from "vue";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
  } from "element-ui";
  import PageTitle from "@/layouts/PageTitle";
  import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


  import { Select, Option, Loading } from "element-ui";
  import { ValidationProvider, extend } from "vee-validate";
  import ServerSideValidation from "../../views/Forms/FormValidation/ServerSideValidation";

  export default {
    name: "app",
    components: {
      ValidationProvider,
      ServerSideValidation,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      PageTitle,
      Multiselect,
      [Select.name]: Select,
      [Option.name]: Option,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        actionTypes: [
          {
            origin: 'Novo Tipo',
            types: [
              { description: '', id: 'new' },
            ]
        },
        {
          origin: 'Tipos Existentes',
          types: [
          ]
        },
        ],
        visit_types: [],
        errors: [],
        visit_type_kind: null,
        visit_type: {},
        enableButton: true,
        disabledInput: false,
        isLoading: false,
        filter: {},
        filtered: false,
        modals: {
          modal0: false,
        },
      };
    },

    mounted() {
      this.setData();
      this.setActionTypes();
    },

    methods: {
      setError(error, text) {
        this.error =
          (error.response && error.response.data && error.response.data.error) ||
          text;
      },
      newVisitType() {
        this.modals.modal0 = true
        this.visit_type.description = this.visit_type.action_type.description;
      },
      setData(q, page) {
        this.isLoading = true;
        if (typeof page === "undefined") page = null;
        if (typeof q === "undefined" || this.emptyFilter) q = null;
        this.$http.secured
          .get("/api/v1/visit_types", {})
          .then((response) => {
            this.visit_types = response.data;
            this.isLoading = false;
          })
          .catch((error) => {
            this.setError(error, "Something went wrong")
            this.isLoading = false;
            });
      },
      setActionTypes() {
        this.isLoading = true;
        this.$http.secured
          .get("/api/v1/action_types", {})
          .then((response) => {
            this.actionTypes[1].types = response.data;
            this.isLoading = false;

          })
          .catch((error) => this.setError(error, "Something went wrong"));
      },
      search() {
        // this.filtered = !this.emptyFilter;
        // this.setData(this.visit_type.kind);
      },
      edit(visit_type) {
        this.visit_type = visit_type;
        this.modals.modal0 = true;
      },
      save () {
      if (!this.visit_type.description) {
            this.$toasted.global.defaultError({msg: 'Por favor, inclua uma descrição!'});
        return;
      };

        this.isLoading=true;

        if (!this.visit_type.id) {
          this.$http.secured
            .post("/api/v1/visit_types", this.visitTypeParams)
            .then((response) => {
              // this.actionTypes[1].types.push(response.data);
              this.$toasted.global.defaultSuccess();
              this.modals.modal0 = false;
              this.setData();
              this.setActionTypes();
              this.visit_type = {};
              this.error = {};
              this.isLoading=false;

            })
            .catch((error) => {
              this.setError(error, "Cannot update user");
            });
        } else {
          this.$http.secured
            .put(`/api/v1/visit_types/${this.visit_type.id}`, this.visit_type)
            .then((response) => {
              this.response = response.data;
              this.modals.modal0 = false;
              this.$toasted.global.defaultSuccess();
              this.setData();
            })
            .catch((error) => this.setError(error, "Cannot update visit Type"));
        }
      },

      remove(visit_type) {
        if (confirm("Deseja excluir esta visita ?")) {
          this.$http.secured
            .delete(`/api/v1/visit_types/${visit_type.id}`, visit_type)
            .then((response) => {
              this.$toasted.global.defaultSuccess();
              this.setData();
              this.visit_types.splice(this.visit_types.indexOf(this.visit_type));
            })
            .catch((error) => this.setError(error, "Cannot delete todo"));
        }
      },
      filteredVisitTypes() {


        if (!this.visit_type.action_type) {
          return this.visit_types;
          }


        return this.visit_types.filter(

          (vt) => {
            return vt.action_type_id === this.visit_type.action_type.id
          }

        );

      },
      updateNewActionType(description){
        if(description)
          this.actionTypes[0].types[0].description = description
      },
      clearFilters() {
        this.visit_type.action_type = {};
      },
    },

    computed: {
      visitTypeParams(){
        if(this.visit_type.action_type.id && this.visit_type.action_type.id != 'new'){
          return {
            description: this.visit_type.description,
            action_type_id: this.visit_type.action_type.id
          }
        } else {
          return {
            description: this.visit_type.description,
            action_type_attributes: this.visit_type.action_type
          }
        }
      }
    },
    watch: {
      'visit_type.action_type'(newVisitType) {
        this.enableButton = !newVisitType;
      },
    },
  };
</script>
